import { Terrain as TerrainIcon } from '@mui/icons-material'
import { Chip, Stack } from '@mui/material'

import { getSportProps, getStatusProps } from '../../utils/utility'

const renderChip = ({ label, icon, color = 'default', size = 'medium' }) => {
  if (!label) return
  return <Chip icon={icon} label={label} variant="outlined" size={size} color={color} />
}

/**
 * InfoChips - 显示信息标签的组件
 * @param {Object} props
 * @param {Object} props.info - 包含信息的对象
 * @returns {JSX.Element}
 */
export default function InfoChips({ info, size = 'medium', sx = {} }) {
  const statusType = getStatusProps(info.status)
  const sportProps = getSportProps(info.sport)
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center" justifyContent="center" sx={sx}>
      {renderChip({ label: info.skiResort, icon: <TerrainIcon />, size })}
      {renderChip({ label: info.location, icon: <TerrainIcon />, size })}
      {renderChip({ label: sportProps?.label, icon: sportProps?.icon, size })}
      {renderChip({ label: statusType?.label, icon: statusType?.icon, color: statusType?.color, size })}
    </Stack>
  )
}
